/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Out_Of_StockInputs */

const vi_shop_group_out_of_stock = /** @type {(inputs: Shop_Group_Out_Of_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết hàng`)
};

/**

* @param {Shop_Group_Out_Of_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_out_of_stock = /** @type {((inputs?: Shop_Group_Out_Of_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Out_Of_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_out_of_stock(inputs)
});